import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import Button from '../../../../../components/global/Button';
import SpecialtyEventUploadFinishMessage from '../SpecialtyEventUploadFinishMessage';
import { getCelebratedPersonName } from '../../../../../apps/pro/views/AlbumFolder/FreemiumEvents/SpecialtyAlbumGreetingModal/helpers';
import { isVideoAlbum } from '../../../../../util/album';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  authenticated: PropTypes.bool.isRequired,
};

const UploadSuccessStep = ({ album, albumFolder, authenticated }) => {
  const history = useHistory();
  const isVideoAlbumBool = isVideoAlbum(album);
  const possessiveCelebratedName = getCelebratedPersonName(
    albumFolder?.album_subtype,
    albumFolder?.event_settings,
    true,
    albumFolder?.account?.organization_name ?? albumFolder?.account?.name,
  );

  return (
    <Fragment>
      <div className="d-flex flex-column align-items-center justify-content-center">
        <h2 className="text-black mb-2 text-center">
          Thanks for your {isVideoAlbumBool ? 'videos' : 'photos'}!
        </h2>
      </div>
      <SpecialtyEventUploadFinishMessage
        uploadedTargets={[album]}
        possessiveCelebratedName={possessiveCelebratedName}
      />
      <hr className="w-100 mt-0 my-2" />
      <h5 className="my-1 text-center text-uppercase text-primary">
        What&apos;s next?
      </h5>
      <Button
        btnOutline
        onClick={() => {
          if (authenticated) {
            history.push(`/app/shutterbug/albums/${album.id}`);
          } else {
            history.push(`/galleries/view/album/${album.id}`);
          }
        }}
      >
        Back to {album.name}
      </Button>
    </Fragment>
  );
};

UploadSuccessStep.propTypes = propTypes;

export default UploadSuccessStep;
